module.exports = __webpack_public_path__ + "passport/img/logo@2x.3c5933e8.png";